import { jsx as _jsx } from "react/jsx-runtime";
import { Label } from 'recharts';
import styles from './ChartAxisLabel.module.css';
const ChartAxisLabel = ({ label, viewBox, fontSize = '0.875rem', dx = -10, position = 'insideLeft', }) => {
    return (_jsx(Label, { className: styles.axisLabel, value: label ? `(${label})` : '', viewBox: viewBox, dx: dx, position: position, fontSize: fontSize }, void 0));
};
export default ChartAxisLabel;
